import React from "react";
//#region types
import { WintSuperkollAPIModelTimeReporting as ApiModel, WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { EventConstants, RouteConstants } from "utils/constants";
//#region components
import { useNavigate, useLocation } from "react-router-dom";
import { useTimeReportingService } from "serviceHooks";
//#endregion
import { DateHelper, EventHelper, UrlHelper } from "utils/helpers";

function useSalaryDeviationAndTimeReportTodoHelper(
  report: ApiModel.SalaryDeviationAndTimeLogReport,
  onActionSuccess: () => void
) {
  const timeReportingService = useTimeReportingService();
  const location = useLocation();
  const navigate = useNavigate();
  const [salaryDeviationAndTimeLog, setSalaryDeviationAndTimeLog] =
    React.useState<ApiModel.SalaryDeviationAndTimeLogReport>(report);
  const [reportData, setReportData] = React.useState<ApiModel.TimeReportingReportRow[]>();

  const [deviationMonthState, setDeviationMonthState] =
    React.useState<WintSuperkollAPIModel.SalaryDeviationMonthState>();

  const [noOfReportsToApprove, setNoOfReportsToApprove] = React.useState<number>();

  React.useEffect(() => {
    setSalaryDeviationAndTimeLog(report);
    fetchReportData();
  }, [report]);

  const fetchReportData = () => {
    timeReportingService.getDueMonthReport().then((res) => {
      loadRowsData(res.data);
      setDeviationMonthState(res.data.salaryDeviationMonthState);
    });
  };

  const loadRowsData = (report?: ApiModel.SalaryDeviationAndTimeLogReport) => {
    const updatedRows = report?.employeeReports
      ?.sort((a, b) => {
        const aApproved = !!(a.columns && a.columns[0].timeReportStatus === ApiModel.TimeReportStatus.Attested)
          ? 1
          : -1;
        const bApproved = !!(b.columns && b.columns[0].timeReportStatus === ApiModel.TimeReportStatus.Attested)
          ? 1
          : -1;
        return aApproved - bApproved;
      })
      .map((row) => (getRowSelected(row) ? { ...row, selected: true, disabled: true } : row));
    setReportData(updatedRows ?? []);
    setSalaryDeviationAndTimeLog(report!);
    setNoOfReportsToApprove(updatedRows?.filter((row) => !(row as any).selected).length ?? 0);
  };

  const getRowSelected = (baseRow: ApiModel.TimeReportingReportRow) => {
    return baseRow.columns && baseRow.columns[0].timeReportStatus === ApiModel.TimeReportStatus.Attested;
  };

  const onRowsUpdate = (rows: ApiModel.TimeReportingReportRow[]) => {
    setReportData(rows);
  };

  const reloadTodo = (onMarkAsDone?: () => void) => {
    const hasColumnInApprovedStatus = (columns: ApiModel.TimeReportingReportColumn[]): boolean => {
      return columns[0].timeReportStatus === ApiModel.TimeReportStatus.Approved;
    };

    if (
      (reportData ?? []).every(
        (row) =>
          (row as any).selected || (!(row as any).selected && row.columns && hasColumnInApprovedStatus(row.columns))
      )
    ) {
      onActionSuccess();
      onMarkAsDone && onMarkAsDone();
    } else {
      fetchReportData();
    }
  };

  const onViewInfoClick = () => {
    if (salaryDeviationAndTimeLog!.businessUnitId) {
      navigate(
        UrlHelper.formatPath(
          `/BusinessUnits/${salaryDeviationAndTimeLog!.businessUnitId}?${
            RouteConstants.TimeReportingQueryParams.Period
          }=${DateHelper.splitYearMonthByCharacter(salaryDeviationAndTimeLog!.yearAndMonth, "-")}`
        ),
        {
          state: { background: location },
        }
      );
    } else {
      navigate(UrlHelper.formatPath(`/Reports/BusinessUnits`), {
        state: { background: location },
      });
    }
    EventHelper.publishEvent(EventConstants.CloseDrawer);
  };

  return {
    salaryDeviationAndTimeLog,
    reportData,
    deviationMonthState,
    noOfReportsToApprove,
    onViewInfoClick,
    fetchReportData,
    onRowsUpdate,
    reloadTodo,
  };
}

export default useSalaryDeviationAndTimeReportTodoHelper;
